import { breakpointDown } from './_functions';

const setVh = () => {
  document.documentElement.style.setProperty('--vh', `${window.innerHeight * 0.01}px`);
};

// Показать\скрыть ПОИСК по клику по иконке
document.querySelectorAll('.block-search .toggler').forEach($target => {
  $target.addEventListener('click', () => {
    if ($target.classList.contains('icon-search')) {
      $target.classList.replace('icon-search', 'icon-close');
      $target.nextElementSibling.querySelector('input').focus();
    } else {
      $target.classList.replace('icon-close', 'icon-search');
    }
  });
});

// Закрываем ПОИСК по Esc
document.querySelectorAll('.block-search input').forEach($target => {
  $target.addEventListener('keyup', ({ code, keyCode }) => {
    if (code === 'Escape' || keyCode === 27) {
      $target.parentElement.parentElement.querySelector('.toggler')?.click();
    }
  });
});

// Показываем \ Скрываем ПОИСК в мобильной версии
document.querySelector('.toggle__search')?.addEventListener('click', event => {
  const $target = event.currentTarget;

  if (document.body.classList.contains('show_search')) {
    document.body.classList.remove('show_search');
    $target.classList.replace('icon-close', 'icon-search');
  } else {
    document.body.classList.add('show_search');
    $target.classList.replace('icon-search', 'icon-close');
  }
});

// НАВИГАЦИЯ, второй уровень - переключение вкладок
document.querySelectorAll('.navbar_sub .navbar_sub-tabs button').forEach($target => {
  $target.addEventListener('click', () => {
    setVh();

    const name = $target.getAttribute('data-tab');
    $target.parentElement.setAttribute('data-active', name);

    // custom scrollbar
    const container = document.querySelector(`.tab__${name}.custom__scroll`);

    if (!breakpointDown('md') && container) {
      import('simplebar').then(({ default: SimpleBar }) => {
        new SimpleBar(container, {
          autoHide: false
        });
      });
    }
  });
});

// для TOUCH экранов - по клику на меню с подкатегориями
document.querySelectorAll('.navbar > ul > li.parent > a').forEach($target => {
  $target.addEventListener('click', event => {
    setVh();

    if (('ontouchstart' in window) || (navigator.maxTouchPoints > 0) || (navigator.msMaxTouchPoints > 0)) {
      event.preventDefault();
    }
  });
});

// НАВИГАЦИЯ, показываем \ Скрываем в мобильной версии
document.querySelectorAll('.toggle__nav').forEach($target => {
  $target.addEventListener('click', () => {
    setVh();

    if (document.body.classList.contains('show_nav')) {
      document.body.classList.remove('show_nav');
      document.querySelector('html')?.classList.remove('no-scroll');
      $target.closest('li')?.classList.remove('active');

      document.querySelectorAll('.toggle__nav').forEach($item => {
        $item.classList.replace('icon-close', 'icon-bar');
      });
    } else {
      document.body.classList.add('show_nav');
      document.querySelector('html')?.classList.add('no-scroll');

      document.querySelectorAll('.toggle__nav').forEach($item => {
        $item.classList.replace('icon-bar', 'icon-close');
      });
    }
  });
});

// НАВИГАЦИЯ, показываем подпункты в мобильной версии
document.querySelectorAll('.navbar > ul > li.parent > a').forEach($target => {
  $target.addEventListener('click', event => {
    setVh();

    if (breakpointDown('lg')) {
      event.preventDefault();
      $target.parentElement.classList.toggle('active');
    }
  });
});

// НАВИГАЦИЯ, кнопка Назад в мобильной версии
document.querySelectorAll('.navbar_sub .back_wrapper .back').forEach($target => {
  $target.addEventListener('click', () => {
    setVh();

    $target.closest('li')?.classList.remove('active');
  });
});

document.addEventListener('click', event => {
  const $target = event.target;

  // клик за пределами формы поиска - закрываем окно поиска
  if (!$target.closest('.block-search') && !$target.classList.contains('toggle__search')) {
    document.querySelectorAll('.block-search .toggler').forEach($elem => {
      $elem.classList.remove('active');
      $elem.classList.replace('icon-close', 'icon-search');
    });

    document.body.classList.remove('show_search');

    document.querySelector('.toggle__search')?.classList.replace('icon-close', 'icon-search');
    document.querySelectorAll('.block-search .toggler').forEach($elem => $elem.classList.remove('active'));
  }

  // клик за пределами навигации в мобильном виде - закрываем навигацию
  if (breakpointDown('md') && document.body.classList.contains('show_nav') && !$target.closest('.container') && !$target.closest('.bs__container') && !$target.classList.contains('container') && !$target.classList.contains('bs__container')) {
    document.body.classList.remove('show_nav');
    document.querySelector('html')?.classList.remove('no-scroll');

    document.querySelectorAll('.toggle__nav').forEach($item => {
      $item.classList.replace('icon-close', 'icon-bar');
    });
  }
}, true);
